import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { nearbyData } from 'src/assets/database/nearbyData';

import nearby1 from 'src/assets/images/user-mobile/map/nearby/popup/nearby-img-1.png';
import nearby2 from 'src/assets/images/user-mobile/map/nearby/popup/nearby-img-2.png';
import nearby3 from 'src/assets/images/user-mobile/map/nearby/popup/nearby-img-3.png';
import nearby4 from 'src/assets/images/user-mobile/map/nearby/popup/nearby-img-4.png';
import nearby5 from 'src/assets/images/user-mobile/map/nearby/popup/nearby-img-5.png';
import nearby6 from 'src/assets/images/user-mobile/map/nearby/popup/nearby-img-6.png';

interface ClickPopupProps {
  id: number;
  onClose: () => void; // 추가
}

const imageMap: Record<number, string> = {
  1: nearby1,
  2: nearby2,
  3: nearby3,
  4: nearby4,
  5: nearby5,
  6: nearby6,
};

export default function ClickPopup({ id, onClose }: ClickPopupProps) {
  const navigate = useNavigate();
  const data = nearbyData.find(item => item.id === id);
  if (!data) return null;

  const imageSrc = imageMap[data.id];

  return (
    <PopupWrapper className="popup-card">
      <Card>
        <CloseBorder onClick={onClose} />
        <Title>{data.title}</Title>
        <Description>{data.description}</Description>
        {imageSrc && <Image src={imageSrc} alt={data.title} />}
        <MoreButton onClick={() => navigate(`/nearbymap/${data.id}`)}>
          자세히 보기
        </MoreButton>
      </Card>
    </PopupWrapper>
  );
}

const PopupWrapper = styled.div`
  width: 100%;
  padding: 16px;
  position: absolute;
  z-index: 1000;
  bottom: env(safe-area-inset-bottom);
  @media (min-width: 640px) {
    width: 608px;
    padding: 16px;
    left: 50%;
    transform: translateX(-50%);
    margin: 0 auto;
  }
`;

const CloseBorder = styled.div`
  width: 36px;
  height: 6px;
  flex-shrink: 0;
  border-radius: 24px;
  background: #909090;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 16px auto;
  cursor: pointer;
`;

const Card = styled.div`
  border-radius: 32px;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.16);
  padding: 8px 20px 20px 20px;
  display: flex;
  flex-direction: column;

  @media (min-width: 640px) {
    width: 608px;
    padding: 16px;
    margin: 0 auto;
  }
`;

const Title = styled.h3`
  color: var(--Font-02_black, #111);
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px; /* 130% */
  letter-spacing: -0.5px;

  margin-bottom: 4px;
`;

const Description = styled.p`
  color: var(--Font-03_Gray, #505050);
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 133.333% */
  letter-spacing: -0.375px;
`;

const Image = styled.img`
  width: 100%;
  height: auto;
  border-radius: 20px;
  margin: 16px 0 16px 0;
`;

const MoreButton = styled.button`
  color: #111;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px; /* 146.667% */
  letter-spacing: -0.375px;

  display: flex;
  width: 100%;
  padding: 11px 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 16px;
  background: #f4f3f4;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.08);
`;
